// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SqGE","inner":"Footer_inner__1dSlB","nextIcon":"Footer_nextIcon__1J8IV","innerLeft":"Footer_innerLeft__visAn"};